"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSchema = void 0;
var _zod = require("zod");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _models = require("../../../models");
var _utils = require("../../../utils");
const useGetSchema = config => {
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  if (!config) {
    return _zod.z.object({});
  }
  const {
    contactEmail,
    contactTelephone,
    password
  } = config;
  let schema = _zod.z.object({});
  schema = _zod.z.object({
    contactEmail: (0, _utils.createFieldSchema)(formatMessage, contactEmail, 'string', undefined, 'email'),
    contactTelephone: (0, _utils.createFieldSchema)(formatMessage, contactTelephone, 'string', undefined, 'phone'),
    password: (0, _utils.createFieldSchema)(formatMessage, password, 'string'),
    loginType: _zod.z.string({
      message: formatMessage(_models.TranslationKey.validationRequired)
    }).min(1, {
      message: formatMessage(_models.TranslationKey.validationRequired)
    }),
    invitationCode: _zod.z.string().optional()
  });
  return schema;
};
exports.useGetSchema = useGetSchema;